import { Field } from "formik";
import { registerWidget } from "./registry";
import { getClassName } from "./utils";
import React from "react";

// Define default widgets: textarea, money, date, address

export const bindTo = (config: any, formikParams: any) => {
  const obj: any = document.getElementById(config.name);
  if (obj?.editor) {
    const editor = obj.editor;
    editor.model.document.on('change:data', () => {
      formikParams.setFieldValue(config.name, editor.getData());
    });
    obj.editor = null;
    obj.ck = editor;
  }
};

export const defaultFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;

  React.useEffect(() => {
    setTimeout(() => {
      const obj: any = document.getElementById(config.name);
      if (obj?.editor) {
        bindTo(config, formikParams);
      }
      else setTimeout(() => {
        bindTo(config, formikParams);
      }, 2000)
    }, 3000);
  }, []);

  return (
    <Field
      {...extraProps}
      name={config.name}
      type={config.type}
      className={getClassName(config)}
      required={undefined}
      id={config.name}
      as={config.multiline ? "textarea" : undefined}
    />
  );
};

export const numberFormField = (config: any, formikParams: any) => {
  const extraProps = config ?? {};
  if (formikParams.handleChange != null)
    extraProps["onChange"] = formikParams.handleChange;
  return (
    <Field
      {...extraProps}
      {...config}
      key={config.key ?? config.name}
      name={config.name}
      type={config.type}
      required={undefined}
      style={config.label ? { marginBotton: "8px" } : undefined}
      className={getClassName(config)}
      id={config.name}
    />
  );
};

// <input type="text" ...> and variants
registerWidget("text", defaultFormField);
registerWidget("email", defaultFormField);
registerWidget("password", defaultFormField);
registerWidget("url", defaultFormField);
registerWidget("number", numberFormField);
registerWidget("search", defaultFormField);
registerWidget("tel", defaultFormField);
